const STORAGE_KEY = "aminii_guest_cart";

const readCart = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const writeCart = (items) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  window.dispatchEvent(new CustomEvent("aminii-guest-cart-updated"));
};

export const getGuestCart = () => readCart();

export const getGuestCartCount = () => {
  return readCart().reduce((sum, item) => sum + (item.quantity || 0), 0);
};

export const addGuestCartItem = (item, options = {}) => {
  const cart = readCart();
  const productId = parseInt(item.productId, 10);
  const size = item.size;
  const existing = cart.find(
    (i) => i.productId === productId && i.size === size
  );

  if (existing) {
    if (!options.preventDuplicate) {
      existing.quantity += item.quantity || 1;
    }
  } else {
    cart.push({
      productId,
      productName: item.productName,
      productImage: item.productImage || "",
      productPrice: item.productPrice,
      beforeDiscountPrice: item.beforeDiscountPrice ?? item.productPrice,
      size,
      quantity: item.quantity || 1,
      sku: item.sku || `SKU-${productId}`,
      hsn: item.hsn || "6204",
      cartId: null,
    });
  }

  writeCart(cart);
  return cart;
};

export const updateGuestCartQty = (productId, size, quantity) => {
  const cart = readCart();
  const idx = cart.findIndex(
    (i) => i.productId === productId && i.size === size
  );
  if (idx === -1) return cart;

  if (quantity <= 0) {
    cart.splice(idx, 1);
  } else {
    cart[idx].quantity = quantity;
  }

  writeCart(cart);
  return cart;
};

export const removeGuestCartItem = (productId, size) => {
  const cart = readCart().filter(
    (i) => !(i.productId === productId && i.size === size)
  );
  writeCart(cart);
  return cart;
};

export const clearGuestCart = () => {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent("aminii-guest-cart-updated"));
};

export const mergeGuestCartToServer = async (api, userId) => {
  const guestItems = readCart();
  if (!guestItems.length) return;

  for (const item of guestItems) {
    try {
      let cartItems = [];
      try {
        const res = await api.get(`/cart/user/${userId}`);
        const data = res.data?.data ?? res.data;
        cartItems = Array.isArray(data) ? data : [];
      } catch (err) {
        if (err.response?.status !== 404) throw err;
      }

      const existing = cartItems.find(
        (c) =>
          c.productId === item.productId && c.cartSize === item.size
      );

      if (existing) {
        await api.put(`/cart/${existing.cartId}`, {
          userId: parseInt(userId, 10),
          productId: item.productId,
          cartSize: item.size,
          cartQty: existing.cartQty + item.quantity,
        });
      } else {
        await api.post("/cart", {
          userId: parseInt(userId, 10),
          productId: item.productId,
          cartSize: item.size,
          cartQty: item.quantity,
        });
      }
    } catch (err) {
      console.warn("Failed to merge guest cart item:", err);
    }
  }

  clearGuestCart();
};
